import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { SEO_CONFIG, ORGANIZATION_STRUCTURED_DATA, SERVICE_STRUCTURED_DATA, WEBSITE_STRUCTURED_DATA } from '../config/seo';

const SEO = ({ 
  page = 'home', 
  title, 
  description, 
  keywords, 
  ogImage, 
  canonical,
  structuredData = []
}) => {
  const pageConfig = SEO_CONFIG.pages[page] || SEO_CONFIG.default;
  
  const finalTitle = title || pageConfig.title;
  const finalDescription = description || pageConfig.description;
  const finalKeywords = keywords || pageConfig.keywords;
  const finalOgImage = ogImage || pageConfig.ogImage;
  const finalCanonical = canonical || `${SEO_CONFIG.default.canonical}${page === 'home' ? '' : `/${page}`}`;

  // Default structured data
  const defaultStructuredData = [
    ORGANIZATION_STRUCTURED_DATA,
    WEBSITE_STRUCTURED_DATA
  ];

  // Add service structured data for service page
  if (page === 'service') {
    defaultStructuredData.push(SERVICE_STRUCTURED_DATA);
  }

  // Combine with custom structured data
  const allStructuredData = [...defaultStructuredData, ...structuredData];

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      <meta name="keywords" content={finalKeywords} />
      <link rel="canonical" href={finalCanonical} />
      
      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={finalOgImage} />
      <meta property="og:url" content={finalCanonical} />
      <meta property="og:type" content={SEO_CONFIG.default.ogType} />
      <meta property="og:site_name" content="PortRay株式会社" />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content={SEO_CONFIG.default.twitterCard} />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={finalOgImage} />
      
      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="PortRay株式会社" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="language" content="ja" />
      <meta name="geo.region" content="JP-13" />
      <meta name="geo.placename" content="東京都" />
      
      {/* Structured Data */}
      {allStructuredData.map((data, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
        />
      ))}
    </Helmet>
  );
};

SEO.propTypes = {
  page: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
  ogImage: PropTypes.string,
  canonical: PropTypes.string,
  structuredData: PropTypes.array
};

export default SEO;
